import { render, staticRenderFns } from "./ReadSeo.vue?vue&type=template&id=f9b27f10&"
import script from "./ReadSeo.vue?vue&type=script&lang=ts&"
export * from "./ReadSeo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports